<script lang="ts" setup>
import {menuMainItems} from "~~/route/route.config";
import type {Cta} from "~/components/button/interface/cta.interface";

const {cta} = defineProps<{
    cta: Cta
}>();
const {locale} = useI18n();
const ctaUri = computed(() => {
    if (cta.url) {
        return cta.url;
    }
    const menuItem = menuMainItems.find(item => item.identifier === cta?.pageRef || '');
    return menuItem?.path?.[locale.value] || '/';
});

const classes: Record<string, string> = {
    'btn': 'btn btn-secondary',
    'btn-secondary': 'btn btn-outline-secondary',
    'default': 'text-secondary border-dotted border-b',
};

const ctaClass = computed(() => {
    if (cta.type && classes?.[cta.type]) {
        return classes[cta.type];
    }
    return classes['default'];
});
</script>

<template>
  <a v-if="cta.url" :href="cta.url" :class="ctaClass">
    {{ cta.label }}
    <slot name="icon-end"/>
  </a>
  <NuxtLink v-else :href="ctaUri" :class="ctaClass">
    {{ cta.label }}
    <slot name="icon-end"/>
  </NuxtLink>
</template>

<style scoped>

</style>